import React, { Component } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Row, Col } from "react-bootstrap";
import CartContext from "./CartContext";

export default class EmployeeActions extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      actions: [],
      employees: [],
      form: {
        id: "",
        employeeId: "",
        date: "",
        description: "",
        status: 0,
      },
      showModal: false,
      isEdit: false,
      isBulk: false,
      filterEmployee: "",
      filterDateRange: "all",
      filterCustomDate: "",
      filterStatus: "", // status filter
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchEmployees();
    this.fetchActions();
  }

  // ✅ don't touch fetchEmployees as you said
  fetchEmployees = () => {
    axios
      .get(
        process.env.REACT_APP_API +
          "Employee/GetEmployees/" +
          this.context.storeId
      )
      .then((res) => {
        this.setState({ employees: res.data });
      })
      .catch(() => this.setState({ error: "Failed to load employees." }));
  };

  fetchActions = () => {
    axios
      .get(
        process.env.REACT_APP_API +
          "EmployeeAction/Store/" +
          this.context.storeId
      )
      .then((res) => this.setState({ actions: res.data }))
      .catch((err) => console.error(err));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      form: { ...prev.form, [name]: value },
    }));
  };

  handleShow = (isEdit = false, action = null, isBulk = false) => {
    if (isEdit && action) {
      this.setState({
        showModal: true,
        isEdit: true,
        isBulk: false,
        form: {
          ...action,
          date: action.date
            ? new Date(action.date).toISOString().split("T")[0]
            : "",
        },
      });
    } else if (isBulk) {
      this.setState({
        showModal: true,
        isEdit: false,
        isBulk: true,
        form: { id: "", date: "", description: "", status: 0 },
      });
    } else {
      this.setState({
        showModal: true,
        isEdit: false,
        isBulk: false,
        form: {
          id: "",
          employeeId: "",
          date: "",
          description: "",
          status: 0,
        },
      });
    }
  };

  handleClose = () => {
    this.setState({ showModal: false, isEdit: false, isBulk: false });
  };

  saveAction = () => {
    const { isEdit, form } = this.state;

    if (!form.employeeId || !form.date) {
      alert("Employee and Date are required!");
      return;
    }

    const payload = {
      storeId: this.context.storeId,
      employeeId: form.employeeId,
      date: new Date(form.date).toISOString(),
      description: form.description,
      status: Number(form.status) || 0,
    };

    const request = isEdit
      ? axios.put(
          process.env.REACT_APP_API + "EmployeeAction/" + form.id,
          payload
        )
      : axios.post(process.env.REACT_APP_API + "EmployeeAction", payload);

    request
      .then(() => {
        this.fetchActions();
        this.handleClose();
      })
      .catch((err) => {
        console.error("Save error:", err.response?.data || err.message);
        alert("Failed to save action: " + (err.response?.data || err.message));
      });
  };

  saveActionForAll = () => {
    const { form } = this.state;

    if (!form.date || !form.description) {
      alert("Date and Description are required for bulk action!");
      return;
    }

    const payload = {
      date: new Date(form.date).toISOString(),
      description: form.description,
      status: Number(form.status) || 0,
    };

    axios
      .post(
        process.env.REACT_APP_API +
          "EmployeeAction/bulk/" +
          this.context.storeId,
        payload
      )
      .then(() => {
        this.fetchActions();
        this.handleClose();
      })
      .catch((err) => {
        console.error("Bulk save error:", err.response?.data || err.message);
        alert(
          "Failed to save bulk actions: " + (err.response?.data || err.message)
        );
      });
  };

  deleteAction = (id) => {
    if (!window.confirm("Are you sure you want to delete this action?")) return;
    axios
      .delete(process.env.REACT_APP_API + "EmployeeAction/" + id)
      .then(() => this.fetchActions())
      .catch(() => alert("Failed to delete action"));
  };

  getStatusLabel = (status) => {
    switch (status) {
      case 0:
        return "Pending";
      case 1:
        return "Completed";
      case 2:
        return "Cancelled";
      default:
        return "Unknown";
    }
  };

  // ✅ fixed employee filter & status filter
  getFilteredActions = () => {
    const {
      actions,
      filterEmployee,
      filterDateRange,
      filterCustomDate,
      filterStatus,
    } = this.state;
    let filtered = [...actions];

    if (filterEmployee) {
      filtered = filtered.filter(
        (a) =>
          a.employee?.firstName === filterEmployee ||
          a.employeeName === filterEmployee
      );
    }

    if (filterStatus !== "") {
      filtered = filtered.filter((a) => String(a.status) === filterStatus);
    }

    const today = new Date();

    if (filterDateRange === "week") {
      const start = new Date(today);
      start.setDate(today.getDate() - 7);
      filtered = filtered.filter(
        (a) => new Date(a.date) >= start && new Date(a.date) <= today
      );
    } else if (filterDateRange === "month") {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      filtered = filtered.filter(
        (a) => new Date(a.date) >= start && new Date(a.date) <= today
      );
    } else if (filterDateRange === "year") {
      const start = new Date(today.getFullYear(), 0, 1);
      filtered = filtered.filter(
        (a) => new Date(a.date) >= start && new Date(a.date) <= today
      );
    } else if (filterDateRange === "custom" && filterCustomDate) {
      const selected = new Date(filterCustomDate);
      filtered = filtered.filter(
        (a) => new Date(a.date).toDateString() === selected.toDateString()
      );
    }

    return filtered;
  };

  render() {
    const {
      employees,
      form,
      showModal,
      isEdit,
      isBulk,
      filterEmployee,
      filterDateRange,
      filterCustomDate,
      filterStatus,
    } = this.state;

    const filteredActions = this.getFilteredActions();

    return (
      <div className="container">
        <div className="py-2 mb-2">
          <h3>
            <b>Employee Actions Management</b>
          </h3>
        </div>
        <Row className="mb-3">
          <Col>
            <Button onClick={() => this.handleShow(false, null, false)}>
              + New Action (One Employee)
            </Button>
          </Col>
          <Col>
            <Button
              variant="secondary"
              onClick={() => this.handleShow(false, null, true)}
            >
              + New Action (All Employees)
            </Button>
          </Col>

          <Col>
            <Form.Control
              as="select"
              value={filterEmployee}
              onChange={(e) =>
                this.setState({ filterEmployee: e.target.value })
              }
            >
              <option value="">All Employees</option>
              {employees.map((e) => (
                <option key={e.id} value={e.firstName}>
                  {e.firstName} {e.lastName}
                </option>
              ))}
            </Form.Control>
          </Col>

          <Col>
            <Form.Control
              as="select"
              value={filterStatus}
              onChange={(e) => this.setState({ filterStatus: e.target.value })}
            >
              <option value="">All Status</option>
              <option value="0">Pending</option>
              <option value="1">Completed</option>
              <option value="2">Cancelled</option>
            </Form.Control>
          </Col>

          <Col>
            <Form.Control
              as="select"
              value={filterDateRange}
              onChange={(e) =>
                this.setState({ filterDateRange: e.target.value })
              }
            >
              <option value="all">All Dates</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom</option>
            </Form.Control>
          </Col>

          {filterDateRange === "custom" && (
            <Col>
              <Form.Control
                type="date"
                value={filterCustomDate}
                onChange={(e) =>
                  this.setState({ filterCustomDate: e.target.value })
                }
              />
            </Col>
          )}
        </Row>

        <Table bordered hover>
          <thead className="table-light">
            <tr>
              <th>Employee</th>
              <th>Date</th>
              <th>Action Request</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredActions.map((a) => (
              <tr key={a.id}>
                <td>
                  {a.employee
                    ? `${a.employee.firstName} ${a.employee.lastName}`
                    : a.employeeName}
                </td>
                <td>{a.date ? new Date(a.date).toLocaleDateString() : ""}</td>
                <td>{a.description}</td>
                <td>{this.getStatusLabel(a.status)}</td>
                <td>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={() => this.handleShow(true, a)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => this.deleteAction(a.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {isBulk
                ? "New Action for All Employees"
                : isEdit
                ? "Edit Action"
                : "New Action"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {!isBulk && (
                <Form.Group className="mb-2">
                  <Form.Label>Employee</Form.Label>
                  <Form.Control
                    as="select"
                    name="employeeId"
                    value={form.employeeId}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Employee</option>
                    {employees.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.firstName} {e.lastName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}
              <Form.Group className="mb-2">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Action Request</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={form.description}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  name="status"
                  value={form.status}
                  onChange={this.handleChange}
                >
                  <option value={0}>Pending</option>
                  <option value={1}>Completed</option>
                  <option value={2}>Cancelled</option>
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            {isBulk ? (
              <Button variant="primary" onClick={this.saveActionForAll}>
                Save for All Employees
              </Button>
            ) : (
              <Button variant="primary" onClick={this.saveAction}>
                {isEdit ? "Update" : "Save"}
              </Button>
            )}
            <Button variant="secondary" onClick={this.handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
